import { Box } from "@mui/material";

function TabPanel({ children, value, index }) {
    return (
        <>
            <div hidden={value !== index}>
                {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
            </div>
        </>
    )
}
export default TabPanel;